import React from "react";
import { SaveButton, TextArea, TextInput } from "../common/Forms";

export const OptionsAnswerComponent = ({
  name,
  type,
  content,
  answers,
  index,
  onChange,
  readOnly,
  response,
}) => {
  const getStyle = () => {
    if (readOnly && ["radio", "checkbox"].includes(type)) {
      if (answers) {
        if (
          response &&
          response.includes(content) &&
          !answers.includes(content)
        ) {
          return `ml-2 px-1 block text-sm font-bold bg-red-600 text-white`;
        }
        if (answers.includes(content)) {
          return `ml-2 px-1 block text-sm font-bold bg-cyan-600 text-white`;
        }
      }
    }
    return `ml-2 px-1 block text-sm font-medium text-zinc-700`;
  };

  return (
    <>
      {type === "rating" && (
        <div className="rating gap-1">
          {new Array(10).fill(null).map((_v, i) => (
            <input
              type="radio"
              name={`rating-${index}`}
              className="mask mask-star-2 border-orange-600 bg-yellow-400"
              key={`rating_${index}_${i}`}
              checked={i < 5}
              onChange={onChange}
              readOnly={readOnly || false}
            />
          ))}
        </div>
      )}
      {type !== "rating" && (
        <div className="flex items-center">
          <input
            id={`${type}-${index}-${content}`}
            name={name}
            type={type}
            className="h-4 w-4 border-zinc-400 bg-white"
            onChange={onChange}
            readOnly={readOnly || false}
            checked={
              (Array.isArray(response)
                ? response.includes(content)
                : response === content) || false
            }
          />
          {typeof content === "string" && (
            <label
              htmlFor={`${type}-${index}-${content}`}
              className={getStyle()}
            >
              {content}
            </label>
          )}
          {typeof content === "object" && (
            <input
              type={content.type}
              placeholder={content.content}
              className="ml-3 w-2/5 rounded border border-solid border-zinc-400 p-1 font-normal placeholder:text-zinc-400 max-md:w-1/2 max-sm:mr-12 max-sm:w-full"
              readOnly={readOnly || false}
              onChange={onChange}
            />
          )}
        </div>
      )}
    </>
  );
};

export const InputAnswerComponent = ({ type, placeholder, readOnly }) => (
  <>
    {type === "text" && (
      <TextInput
        placeholder={placeholder}
        readOnly={readOnly || false}
        className="w-3/5 resize-none rounded border border-solid border-zinc-400 p-1 font-normal placeholder:text-zinc-400 max-md:w-1/2 max-sm:mr-12 max-sm:w-full"
      />
    )}
    {type === "textarea" && (
      <TextArea
        placeholder={placeholder}
        readOnly={readOnly || false}
        className="w-3/5 p-1 max-md:w-1/2 max-sm:mr-12 max-sm:w-full"
      />
    )}
  </>
);

const FormTemplate = ({ title, description, list }) => {
  return (
    <div className="container mx-auto lg:my-8 lg:max-w-screen-lg">
      <div className="lg:rounded-t-3xl bg-cyan-500 px-6 py-4 md:px-10 md:py-8">
        <h1 className="break-keep md:text-5xl text-3xl leading-tight text-white font-bold">
          {title}
        </h1>
        <h3 className="mt-6 break-keep text-white">
          {description.map((v) => (
            <p>{v}</p>
          ))}
        </h3>
      </div>
      <div className="md:rounded-b-3xl border-t border-zinc-200 bg-white md:p-8 shadow">
        <div className="text-black px-2">
          <span className="mr-1 ordinal text-red-600">*</span>필수
        </div>
        <ol className="my-4 ml-6 sm:ml-10 list-decimal">
          {list.map(({ q, option }, i) => (
            <li className="mb-8 font-semibold text-black">
              {q.content &&
                q.content.map((v, i) => (
                  <>
                    <span className={i > 0 ? "block" : ""}>{v}</span>
                    {i === 0 && q.required && (
                      <span className="ordinal text-red-600"> *</span>
                    )}
                  </>
                ))}
              <fieldset>
                <div className="mt-4 ml-4 space-y-4">
                  {Array.isArray(option) ? (
                    option.map(({ content }) => (
                      <OptionsAnswerComponent
                        {...{ type: q.type, content, index: i }}
                      />
                    ))
                  ) : (
                    <TextArea
                      placeholder={option.content}
                      className="w-3/5 p-1 max-md:w-1/2 max-sm:mr-12 max-sm:w-full"
                    />
                  )}
                </div>
              </fieldset>
            </li>
          ))}
        </ol>
        <SaveButton>제출</SaveButton>
      </div>
    </div>
  );
};

export default FormTemplate;
